import { FormErrorModel } from 'components/modals/fields-summary'
import { FlagsContextModel } from 'config/useFlagsContext'
import {
  AgendamentoConsultaAtendimentoInput,
  AgendamentoConsultasAtendimentoInput,
  AgendamentoConsultasPlanejadasAtendimentoInput,
  AtendimentoIndividualInput,
  AtestadoPlanoInput,
  AvaliacaoDesenvolvimentoInput,
  AvaliacaoInput,
  CompartilhamentoCuidadoPlanoInput,
  CuidadoCompartilhadoPlanoInput,
  EncaminhamentoExternoInput,
  EncerrarGestacaoInput,
  ExameFisicoInput,
  FinalizacaoAtendimentoInput,
  InformacoesObstetricasInput,
  MarcadoresConsumoAlimentarInput,
  MChatRfPerguntaRespostaInput,
  MedicoesInput,
  ObjetivoInput,
  PessoalAntecedentesInput,
  PlanoInput,
  PreNatalInput,
  PuericulturaInput,
  RastreioCancerInput,
  ResultadoExameEspecializadoInput,
  ResultadoExameInput,
  SolicitacaoExameInput,
  SubjetivoInput,
  VigilanciaEmSaudeBucalEnum,
} from 'graphql/types.generated'
import { isObjectDeepEmpty } from 'util/object'
import { ErrorObject } from 'util/validation'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { AntropometriaAccordionModel } from 'view/atendimentos/components/MedicoesPanel/AntropometriaAccordion'
import { SinaisVitaisAccordionModel } from 'view/atendimentos/components/MedicoesPanel/SinaisVitaisAccordion'

import { InformacoesObstetricasPanelModel } from '../../antecedentes/InformacoesObstetricasPanel'
import { PessoalAntecedentesModel } from '../../antecedentes/model-antecedentes'
import { AvaliacaoFormModel } from '../../avaliacao/AvaliacaoForm'
import { NecessidadeProteseEnum } from '../../avaliacao/components/necessidade-protese/model'
import { FinalizacaoAtendimentoFormModel } from '../../finalizacao'
import {
  AgendarConsultaSectionModel,
  AgendarProximasConsultasSectionModel,
} from '../../finalizacao/components/agendar-consulta/model-agendarConsultaAtendimento'
import { ObjetivoFormModel } from '../../objetivo'
import { MarcadoresConsumoPanelModel } from '../../objetivo/marcadores-consumo-alimentar/model'
import { AlteracoesFenotipicasModel } from '../../objetivo/puericultura/alteracao-fenotipica/AlteracaoFenotipicaView'
import { FatoresRiscoModel } from '../../objetivo/puericultura/fatores-risco/FatoresRiscoView'
import { MarcoFormSectionAccordionModel } from '../../objetivo/puericultura/marcos/MarcoFormSectionAccordion'
import { PuericulturaModel } from '../../objetivo/puericultura/model'
import {
  AllResultadoEspecificoValueType,
  ResultadosExamesSolicitadosModel,
} from '../../objetivo/resultados-exames/model-resultadosExames'
import AtestadoModel from '../../plano/atestados/components/model-atestado'
import { getIsVinculacaoCuidadoAtiva } from '../../plano/cuidado-compartilhado/cuidado-compartilhado-form/utils-cuidadoCompartilhado'
import { CuidadoCompartilhadoPlanoModel } from '../../plano/cuidado-compartilhado/model-cuidadocompartilhado'
import {
  EncaminhamentoExternoEspecializadoPlanoModel,
  EncaminhamentosModel,
} from '../../plano/encaminhamento-externo/model-encaminhamentoExterno'
import { RequisicaoExameCitopatologicoFormValues } from '../../plano/exames/components/requisicao-exame/citopatologico/model-citopatologico'
import { RequisicaoExameMamografiaFormValues } from '../../plano/exames/components/requisicao-exame/mamografia/model-mamografia'
import { SolicitacaoExameModel } from '../../plano/exames/model-solicitacaoExames'
import { PlanoFormModel } from '../../plano/PlanoForm'
import { PreNatalFormModel } from '../../pre-natal/model-preNatal'
import { SubjetivoFormModel } from '../../subjetivo'

export const convertSoapErrorsFromBackend = (
  errors: ErrorObject<AtendimentoIndividualInput>,
  flags: FlagsContextModel,
  isAtendimentoOdonto: boolean
): ErrorObject<SoapState> & FormErrorModel => {
  const errorObject = {
    antecedentes: safeString<AtendimentoIndividualInput['antecedentes'], SoapState['antecedentes']>(
      errors?.antecedentes,
      (antecedentes) => ({
        familiar: safeString(antecedentes?.familiar, (familiar) => ({
          ciaps: familiar?.ciaps,
        })),
        pessoal: safeString<PessoalAntecedentesInput, PessoalAntecedentesModel>(antecedentes?.pessoal, (pessoal) => ({
          texto: pessoal?.texto,
          cirurgiasInternacoes: pessoal.cirurgiasInternacoes,
          informacoesObstetricas: safeString<InformacoesObstetricasInput, InformacoesObstetricasPanelModel>(
            pessoal?.informacoesObstetricas,
            (informacoesObstetricas) => ({
              abortos: informacoesObstetricas?.abortos as string,
              filhosVivos: informacoesObstetricas?.filhosVivos as string,
              gestaPrevias: informacoesObstetricas?.gestaPrevias as string,
              nascidosVivos: informacoesObstetricas?.nascidosVivos as string,
              natimortos: informacoesObstetricas?.natimortos as string,
              obitoAntesPrimeiraSemana: informacoesObstetricas?.obitoAntesPrimeiraSemana as string,
              obitoAposPrimeiraSemana: informacoesObstetricas?.obitoAposPrimeiraSemana as string,
              desfechoUltimaGestacao: informacoesObstetricas?.desfechoUltimaGestacao,
              partos: informacoesObstetricas?.partos as string,
              partosCesareas: informacoesObstetricas?.partosCesareas as string,
              partosDomiciliares: informacoesObstetricas?.partosDomiciliares as string,
              partosVaginais: informacoesObstetricas?.partosVaginais as string,
              recemNascidoAbaixo: informacoesObstetricas?.recemNascidoAbaixo as string,
              recemNascidoAcima: informacoesObstetricas?.recemNascidoAcima as string,
            })
          ),
        })),
      })
    ),
    subjetivo: safeString<SubjetivoInput, SubjetivoFormModel>(errors?.subjetivo, (subjetivo) => ({
      texto: subjetivo?.texto,
      motivos: subjetivo?.motivos,
    })),
    objetivo: safeString<ObjetivoInput, ObjetivoFormModel>(errors?.objetivo, (objetivo) => ({
      texto: objetivo?.texto,
      dum: (objetivo?.medicoes as ErrorObject<MedicoesInput>)?.dum as string,
      sinaisVitais: safeString<MedicoesInput, SinaisVitaisAccordionModel>(objetivo?.medicoes, (medicoes) => ({
        frequenciaCardiaca: medicoes?.frequenciaCardiaca as string,
        frequenciaRespiratoria: medicoes?.frequenciaRespiratoria as string,
        glicemia: medicoes?.glicemia as string,
        pressaoArterialDiastolica: medicoes?.pressaoArterialDiastolica as string,
        pressaoArterialSistolica: medicoes?.pressaoArterialSistolica as string,
        saturacaoO2: medicoes?.saturacaoO2 as string,
        temperatura: medicoes?.temperatura as string,
        tipoGlicemia: medicoes?.tipoGlicemia,
      })),
      antropometria: safeString<MedicoesInput, AntropometriaAccordionModel>(objetivo?.medicoes, (medicoes) => ({
        altura: medicoes?.altura as string,
        circunferenciaAbdominal: medicoes?.circunferenciaAbdominal as string,
        perimetroCefalico: medicoes?.perimetroCefalico as string,
        perimetroPanturrilha: medicoes?.perimetroPanturrilha as string,
        peso: medicoes?.peso as string,
        pele: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).pele,
        olhoDireito: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).olhoDireito,
        olhoEsquerdo: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).olhoEsquerdo,
        ouvidoDireito: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).ouvidoDireito,
        ouvidoEsquerdo: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).ouvidoEsquerdo,
        membroInferiorDireito: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).membroInferiorDireito,
        membroInferiorEsquerdo: (medicoes.exameFisico as ErrorObject<ExameFisicoInput>).membroInferiorEsquerdo,
        valorForcaMuscMaoDireita: medicoes.valorForcaMuscMaoDireita as string,
        unidadeForcaMuscMaoDireita: medicoes.unidadeForcaMuscMaoDireita,
        valorForcaMuscMaoEsquerda: medicoes.valorForcaMuscMaoEsquerda as string,
        unidadeForcaMuscMaoEsquerda: medicoes.unidadeForcaMuscMaoEsquerda,
      })),

      marcadoresConsumoAlimentar: safeString<MarcadoresConsumoAlimentarInput, MarcadoresConsumoPanelModel>(
        objetivo?.marcadoresConsumoAlimentar,
        (marcadoresConsumoAlimentar) =>
          marcadoresConsumoAlimentar?.respostas as ErrorObject<MarcadoresConsumoPanelModel>
      ),
      necessidadesEspeciais: objetivo?.necessidadesEspeciais,
      atendimentosEspecificos: {
        puericultura: safeString<PuericulturaInput, PuericulturaModel>(objetivo?.puericultura, (puericultura) => ({
          alteracoesFenotipicas: safeString<ReadonlyArray<AvaliacaoDesenvolvimentoInput>, AlteracoesFenotipicasModel>(
            puericultura?.alteracoesFenotipicas,
            (alteracoesFenotipicas) => ({
              alteracoesFenotipicas,
            })
          ),
          marcosDesenvolvimento: safeString<
            ReadonlyArray<AvaliacaoDesenvolvimentoInput>,
            MarcoFormSectionAccordionModel
          >(puericultura?.marcosDesenvolvimento, (marcosDesenvolvimento) => ({
            marcosRecord: marcosDesenvolvimento as any,
          })),
          tipoAleitamento: puericultura?.tipoAleitamento,
          fatoresRisco: safeString<ReadonlyArray<AvaliacaoDesenvolvimentoInput>, FatoresRiscoModel>(
            puericultura?.fatoresRisco,
            (fatoresRisco) => ({
              fatoresRisco,
            })
          ),
          prenatalPartoNascimento: safeString<
            PuericulturaInput['prenatalPartoNascimento'],
            PuericulturaModel['prenatalPartoNascimento']
          >(puericultura?.prenatalPartoNascimento, (prenatalPartoNascimento) => ({
            antropometriaAoNascer: {
              comprimento: prenatalPartoNascimento?.altura as string,
              perimetroCefalico: prenatalPartoNascimento?.perimetroCefalico as string,
              peso: prenatalPartoNascimento?.peso as string,
            },
            apgar: {
              apgarCinco: prenatalPartoNascimento?.apgarQuintoMinuto,
              apgarDez: prenatalPartoNascimento?.apgarDecimoMinuto,
              apgarUm: prenatalPartoNascimento?.apgarPrimeiroMinuto,
            },
            idadeGestacional: {
              dias: prenatalPartoNascimento?.idadeGestacionalEmDias,
              semanas: prenatalPartoNascimento?.idadeGestacionalEmSemanas,
            },
            tipoGravidez: prenatalPartoNascimento?.tipoGravidez,
            tipoParto: prenatalPartoNascimento?.tipoParto,
          })),
          mChatRf: safeString<PuericulturaInput['mChat'], PuericulturaModel['mChatRf']>(
            puericultura?.mChat,
            (mChatRf) => ({
              mchat: typeof mChatRf?.aplicacaoMChatR === 'string' ? mChatRf.aplicacaoMChatR : undefined,
              consultaSeguimento: (mChatRf.aplicacaoMChatRf as ErrorObject<MChatRfPerguntaRespostaInput>)?.pergunta,
            })
          ),
        })),
      },
      resultadosExames: safeString<ObjetivoInput['resultadosExame'], ObjetivoFormModel['resultadosExames']>(
        objetivo?.resultadosExame,
        (resultadosExame) => {
          return {
            resultadosComSolicitacao: resultadosExame?.map(converterResultadoExame),
            resultadosSemSolicitacao: null,
          } as any
        }
      ),
      anexoArquivos: objetivo?.anexoArquivos,
    })),
    avaliacao: safeString<AvaliacaoInput, AvaliacaoFormModel>(errors?.avaliacao, (avaliacao) => ({
      texto: avaliacao?.texto,
      alergias: avaliacao?.alergiasAvaliadas,
      encerrarGestacao: safeString<EncerrarGestacaoInput, SoapState['avaliacao']['encerrarGestacao']>(
        avaliacao?.encerrarGestacao,
        (encerrarGestacao) => ({
          dataDesfecho: encerrarGestacao?.dataDesfecho as string,
          tipoGravidez: encerrarGestacao?.tipoGravidez,
        })
      ),
      problemasECondicoes: avaliacao?.problemasCondicoesAvaliadas,
      necessidadeProtese: safeString<AvaliacaoInput['vigilanciaSaudeBucal'], NecessidadeProteseEnum>(
        avaliacao?.vigilanciaSaudeBucal,
        (vigilanciaSaudeBucal) => vigilanciaSaudeBucal?.necessidadeProtese as ErrorObject<NecessidadeProteseEnum>
      ),
      tiposVigilancia: safeString<AvaliacaoInput['vigilanciaSaudeBucal'], VigilanciaEmSaudeBucalEnum[]>(
        avaliacao?.vigilanciaSaudeBucal,
        (vigilanciaSaudeBucal) => vigilanciaSaudeBucal?.tiposVigilancia as ErrorObject<VigilanciaEmSaudeBucalEnum[]>
      ),
    })),
    plano: safeString<PlanoInput, PlanoFormModel>(errors?.plano, (plano) => ({
      texto: plano?.texto,
      startObservacao: plano?.isObservacao,
      atestado: {
        atestadosRecentes: safeString<AtestadoPlanoInput, AtestadoModel[]>(
          plano?.atestado,
          (atestado) => (atestado?.emBranco ?? atestado?.licencaMaternidade ?? atestado?.padrao) as string[]
        ),
      },
      encaminhamentoExterno: safeString<
        PlanoInput['encaminhamentosExternosEspecializados'],
        EncaminhamentoExternoEspecializadoPlanoModel
      >(plano?.encaminhamentosExternosEspecializados, (encaminhamentos) => {
        return {
          encaminhamentosEspecializadosRecentes: encaminhamentos?.map(converterEncaminhamentoEspecializado),
          encaminhamentosRecentes: plano?.encaminhamentosExternos,
        } as any
      }),
      intervencoesProcedimentos: {
        ciaps: plano?.ciaps,
        procedimentos: plano?.procedimentos,
      },
      orientacao: plano?.orientacoes,
      prescricaoMedicamento: {
        medicamentos: safeString<
          PlanoInput['prescricaoMedicamento'],
          PlanoFormModel['prescricaoMedicamento']['medicamentos']
        >(plano?.prescricaoMedicamento, (prescricaoMedicamento) => prescricaoMedicamento?.medicamentos as string[]),
      },
      solicitacoesExame: safeString<PlanoInput['solicitacoesExame'], PlanoFormModel['solicitacoesExame']>(
        plano?.solicitacoesExame,
        (solicitacoes) => solicitacoes?.map(converterSolicitacaoExame)
      ),
      odontologia:
        typeof plano?.odontologia === 'string'
          ? ({ evolucoes: plano.odontologia } as any)
          : safeString<PlanoInput['odontologia'], PlanoFormModel['odontologia']>(plano?.odontologia, (odontologia) => ({
              odontograma: {
                dentes: safeString(odontologia?.evolucoesDente, () => null),
              },
            })),
      cuidadosCompartilhado: getIsVinculacaoCuidadoAtiva(flags, isAtendimentoOdonto)
        ? safeString<PlanoInput['compartilhamentosCuidado'], PlanoFormModel['cuidadosCompartilhado']>(
            plano?.compartilhamentosCuidado,
            convertCuidadoCompartilhadoDefault
          )
        : safeString<PlanoInput['cuidadosCompartilhado'], PlanoFormModel['cuidadosCompartilhado']>(
            plano?.cuidadosCompartilhado,
            convertCuidadoCompartilhadoAtendimentoOdonto
          ),
    })),
    finalizacao: safeString<FinalizacaoAtendimentoInput, FinalizacaoAtendimentoFormModel>(
      errors?.finalizacao,
      (finalizacao) => ({
        agendamentoConsultas: safeString<
          FinalizacaoAtendimentoInput['agendamentoConsultas'],
          FinalizacaoAtendimentoFormModel['agendamentoConsultas']
        >(finalizacao?.agendamentoConsultas, (agendamentoConsultas: AgendamentoConsultasAtendimentoInput) => ({
          avulsa: safeString<AgendamentoConsultaAtendimentoInput, AgendarConsultaSectionModel>(
            agendamentoConsultas.avulsa,
            converterAgendamentoConsulta
          ),
          proximasConsultas: safeString<
            AgendamentoConsultasPlanejadasAtendimentoInput,
            AgendarProximasConsultasSectionModel
          >(agendamentoConsultas.planejadas, (consultasPlanejadas) => ({
            proximaConsultaPreNatal: safeString<AgendamentoConsultaAtendimentoInput, AgendarConsultaSectionModel>(
              consultasPlanejadas.preNatal,
              converterAgendamentoConsulta
            ),
            proximaConsultaOdontologica: safeString<AgendamentoConsultaAtendimentoInput, AgendarConsultaSectionModel>(
              consultasPlanejadas.odontologica,
              converterAgendamentoConsulta
            ),
          })),
        })),
        atendimentoCompartilhadoLotacao: finalizacao?.atendimentoCompartilhadoLotacaoId,
        conduta: finalizacao?.condutas,
        condutasOdonto: finalizacao?.condutasOdonto,
        desfechoAtendimento: safeString<
          FinalizacaoAtendimentoInput['desfechoAtendimento'],
          FinalizacaoAtendimentoFormModel['desfechoAtendimento']
        >(finalizacao?.desfechoAtendimento, (desfechoAtendimento) => ({
          manterCidadaoLista: desfechoAtendimento?.manterCidadaoLista as string,
          atendimento: safeString<
            FinalizacaoAtendimentoInput['desfechoAtendimento']['atendimento'],
            FinalizacaoAtendimentoFormModel['desfechoAtendimento']['atendimento']
          >(desfechoAtendimento?.atendimento, (atendimento) => ({
            agendado: atendimento?.agendado,
            equipe: atendimento?.equipe,
            responsavel: atendimento?.responsavel,
            tiposServico: atendimento?.responsavel,
          })),
        })),
        fichasNotificacaoCasoSuspeito: finalizacao?.fichaNotificacaoCasoSuspeito,
        fornecimento: finalizacao?.fornecimentosOdonto,
        procedimentosAdministrativos: finalizacao?.procedimentosAdministrativos,
        racionalidadeEmSaude: finalizacao?.racionalidadeEmSaude,
        tipoAtendimento: finalizacao?.tipoAtendimento as string,
        tipoConsulta: finalizacao?.tipoConsultaOdonto,
      })
    ),
    lembretes: errors?.lembretes,
    medicamentosInterromper: errors?.medicamentoInterromper,
    medicoesAnteriores: errors?.medicoesAnteriores as string,
    preNatal: safeString<PreNatalInput, PreNatalFormModel>(errors?.preNatal, (preNatal) => ({
      alturaUterina: preNatal?.alturaUterina,
      batimentoCardiacoFetal: preNatal?.batimentoCardiacoFetal,
      batimentoCardiacoFetal2: preNatal?.batimentoCardiacoFetal2,
      edema: preNatal?.edema,
      gravidezPlanejada: preNatal?.gravidezPlanejada as string,
      movimentacaoFetal: preNatal?.movimentacaoFetal as string,
      tipoGravidez: preNatal?.tipoGravidez,
    })),
    problemasECondicoes: errors?.problemasECondicoes,
    vacinacao: errors?.registrosVacinacao as string,
  }
  const formError = errors?.['FINAL_FORM/form-error']
  const errorsSemFormError = Object.fromEntries(
    Object.entries(errors).filter(([key]) => key !== 'FINAL_FORM/form-error')
  )
  if (isObjectDeepEmpty(errorsSemFormError)) {
    errorObject['formError'] = formError
  }
  return errorObject
}

function safeString<A, B>(
  error: string | ErrorObject<A>,
  safeError: (input: ErrorObject<A>) => ErrorObject<B>
): ErrorObject<B> | string {
  return typeof error === 'object' ? (safeError(error) as ErrorObject<B>) : (error as string)
}

const converterAgendamentoConsulta = (agendamento: ErrorObject<AgendamentoConsultaAtendimentoInput>) => ({
  lotacao: agendamento?.lotacao,
  horario: agendamento?.horario,
  isForaUbs: agendamento?.isForaUbs,
  localAtendimento: agendamento?.localAtendimento,
  observacoes: agendamento?.observacoes,
})

const convertCuidadoCompartilhadoAtendimentoOdonto = (cuidadosCompartilhado) =>
  cuidadosCompartilhado?.map((cuidadoCompartilhado: ErrorObject<CuidadoCompartilhadoPlanoInput> | string):
    | ErrorObject<CuidadoCompartilhadoPlanoModel>
    | string => {
    return typeof cuidadoCompartilhado === 'string'
      ? cuidadoCompartilhado
      : {
          lotacao: cuidadoCompartilhado?.lotacaoExecutanteId,
          problemasECondicoes: {
            cid10: cuidadoCompartilhado?.cid10,
            ciap: cuidadoCompartilhado?.ciap,
          },
          prioridade: cuidadoCompartilhado?.classificacaoPrioridade,
          discussao: cuidadoCompartilhado?.discussao,
          cidadaoAceitaAtendTic: cuidadoCompartilhado?.cidadaoAceitaAtendTic as string,
        }
  })

const convertCuidadoCompartilhadoDefault = (compartilhamentosCuidado) =>
  compartilhamentosCuidado?.map((compartilhamentoCuidado: ErrorObject<CompartilhamentoCuidadoPlanoInput> | string):
    | ErrorObject<CuidadoCompartilhadoPlanoModel>
    | string => {
    return typeof compartilhamentoCuidado === 'string'
      ? compartilhamentoCuidado
      : {
          editingId: compartilhamentoCuidado.id,
          lotacao: compartilhamentoCuidado?.lotacaoExecutanteId,
          problemasECondicoes: {
            cid10: compartilhamentoCuidado?.cid10,
            ciap: compartilhamentoCuidado?.ciap,
          },
          prioridade: compartilhamentoCuidado?.classificacaoPrioridade,
          discussao: compartilhamentoCuidado?.discussao,
          cidadaoAceitaAtendTic: compartilhamentoCuidado?.cidadaoAceitaAtendTic as string,
          cbo: compartilhamentoCuidado.cboId,
          unidadeSaude: compartilhamentoCuidado.unidadeSaudeId,
          tipo: compartilhamentoCuidado.isEncaminhamento as string,
          especialidade: compartilhamentoCuidado.especialidadeId,
        }
  })

const converterResultadoEspecifico = (
  especifico: ErrorObject<ResultadoExameEspecializadoInput>
): ErrorObject<AllResultadoEspecificoValueType> =>
  ({
    dpp: especifico?.dpp as string,
    fichaComplementarPuericultura: especifico?.fichaComplementarPuericultura as string,
    igDias: especifico?.igDias as string,
    igSemanas: especifico?.igSemanas as string,
    procedimento: especifico?.procedimento as string,
    resultadoExameEstruturadoQualitativo: especifico?.resultadoExameEstruturadoQualitativo as string,
    valor: especifico?.valor as string,
  } as ErrorObject<AllResultadoEspecificoValueType>)

const converterResultadoExame = (resultadoExame: string | ErrorObject<ResultadoExameInput> | undefined) => {
  if (!resultadoExame) {
    return undefined
  }

  return safeString<ResultadoExameInput, ResultadosExamesSolicitadosModel>(
    resultadoExame,
    (resultadoExameErrors): ErrorObject<ResultadosExamesSolicitadosModel> => ({
      exame: resultadoExameErrors?.exameId as string,
      dataRealizado: resultadoExameErrors?.dataRealizacao as string,
      dataSolicitado: resultadoExameErrors?.dataSolicitacao as string,
      dataResultado: resultadoExameErrors?.dataResultado as string,
      resultado: resultadoExameErrors?.especifico
        ? safeString<ResultadoExameEspecializadoInput, AllResultadoEspecificoValueType>(
            resultadoExameErrors.especifico,
            converterResultadoEspecifico
          )
        : (resultadoExameErrors?.resultado as string),
      descricao: resultadoExameErrors?.especifico ? (resultadoExameErrors?.resultado as string) : undefined,
      editingId: resultadoExameErrors?.id as string,
    })
  )
}

const converterEncaminhamentoEspecializado = (
  encaminhamento: string | ErrorObject<EncaminhamentoExternoInput> | undefined
) => {
  if (!encaminhamento) {
    return undefined
  }

  return safeString<EncaminhamentoExternoInput, EncaminhamentosModel>(
    encaminhamento,
    (encaminhamentoErrors: ErrorObject<EncaminhamentoExternoInput>) =>
      ({
        editingId: encaminhamentoErrors?.id,
        especialidadeSisreg: encaminhamentoErrors?.especialidadeSisreg,
        classificacaoRiscoEncaminhamento: encaminhamentoErrors?.classificacaoRiscoEncaminhamento,
        cidEncaminhamento: encaminhamentoErrors?.hipoteseDiagnosticoCid10,
        ciapEncaminhamento: encaminhamentoErrors?.hipoteseDiagnosticoCiap,
        motivoEncaminhamento: encaminhamentoErrors?.motivoEncaminhamento,
        complemento: encaminhamentoErrors?.complemento,
        observacoes: encaminhamentoErrors?.observacoes,
      } as ErrorObject<EncaminhamentosModel>)
  )
}

const converterSolicitacaoExame = (solicitacaoExame: string | ErrorObject<SolicitacaoExameInput> | undefined) => {
  if (!solicitacaoExame) {
    return undefined
  }

  return safeString<SolicitacaoExameInput, SolicitacaoExameModel>(
    solicitacaoExame,
    (solicitacaoExameErrors: ErrorObject<SolicitacaoExameInput>) => {
      const rastreioCito = solicitacaoExameErrors?.rastreioCitopatologicoColoUtero
      const rastreioCitoToConvert = Array.isArray(rastreioCito) ? rastreioCito[0] : rastreioCito

      const rastreioCitoFormatado =
        rastreioCitoToConvert &&
        safeString<RastreioCancerInput, RequisicaoExameCitopatologicoFormValues>(
          rastreioCitoToConvert,
          (rastreioErrors: ErrorObject<RastreioCancerInput>) =>
            ({
              ...rastreioErrors,
            } as ErrorObject<RequisicaoExameCitopatologicoFormValues>)
        )

      const rastreioMamo = solicitacaoExameErrors?.rastreioMamografia
      const rastreioMamoToConvert = Array.isArray(rastreioMamo) ? rastreioMamo[0] : rastreioMamo

      const rastreioMamoFormatado =
        rastreioMamoToConvert &&
        safeString<RastreioCancerInput, RequisicaoExameMamografiaFormValues>(
          rastreioMamoToConvert,
          (rastreioErrors: ErrorObject<RastreioCancerInput>) =>
            ({
              ...rastreioErrors,
            } as ErrorObject<RequisicaoExameMamografiaFormValues>)
        )

      return {
        ...solicitacaoExameErrors,
        rastreioCitopatologicoColoUtero: rastreioCitoFormatado,
        rastreioMamografia: rastreioMamoFormatado,
      } as ErrorObject<SolicitacaoExameModel>
    }
  )
}
